module.exports = __webpack_public_path__ + "src/assets/static/img/footer-brand-1.872874f9.png";